const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname === 'venue.peiso.com.au') {
    return 'main';
  } else if (hostname === 'lucasrestaurants.peiso.com.au') {
    return 'lucas';
  } else if (hostname === 'sandbox-venue.peiso.com.au') {
    return 'sandbox';
  }
  return 'local';
};

/**
 * @type {Array<{NAME: string, API_BASE_URL: string}>}
 */
const environments = {
  main: {
    NAME: 'main',
    API_BASE_URL: 'https://main.peiso.au/api',
    BASE_URL: 'https://main.peiso.au',
  },
  lucas: {
    NAME: 'lucas',
    API_BASE_URL: '',
    BASE_URL: '',
  },
  sandbox: {
    NAME: 'sandbox',
    API_BASE_URL: 'https://sandbox.peiso.dev/api',
    BASE_URL: 'https://sandbox.peiso.dev',
  },
  local: {
    NAME: 'local',
    API_BASE_URL: 'http://localhost:8080/api',
    BASE_URL: 'http://localhost:8080',
  }
};

export const env = environments[getEnvironment()];



// WEBPACK FOOTER //
// ./src/env.js